import { HttpClient } from '@lib/HttpClient';
import { getLang } from '@root/src/i18n/client';

export async function getContentBySlug(slug: string) {
  try {
    const data = await HttpClient.httpGet(
      `/content/slug/${slug}?lang=${getLang()}`
    );
    return data;
  } catch (error) {
    console.error('Error fetching content:', error);
    return null;
  }
}
